// TODO: These are a little inconsistent right now and should be revisted at
// some point
export const SEARCH_KEY = "analysisSearch";

export const MONITORING_LS_KEY = "Monitoring-groups";

export const INSIGHTS_LS_KEY = "Insights-groups";

export const SORT_BY_KEY = "sortBy";
export const GROUP_BY_KEY = "groupBy";

export const EXPANDING_KEY = {
  monitoring: "monitoring-expanded",
  insights: "insights-expanded",
};
